import { UserChoicesAndWrongs } from 'store/userChoicesAndWrongsGroup'
import { CheckDailyQuestionQueryType, DailyQuestionChoiceType } from '@lib/query/mutateFunction'

const getQueryForDailyCheck = (
  dailyDeliveryId: number,
  questionInformation: UserChoicesAndWrongs = {}
) => {
  const questionChoices: DailyQuestionChoiceType[] = Object.keys(questionInformation).map(
    (questionNumber, index) => {
      return {
        questionId: Number(questionInformation[index + 1].id),
        choice: Number(questionInformation[index + 1].choice),
      }
    }
  )
  const queryForCheck: CheckDailyQuestionQueryType = {
    dailyDeliveryId: Number(dailyDeliveryId),
    questionChoices,
  }
  return queryForCheck
}

export default getQueryForDailyCheck
